// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .gc-form-section {
  border: 1px solid #D1D5DB;
  border-radius: 12px;
  margin-bottom: 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form {
  padding: 25px;
}
:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1E38A9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea {
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 7rem;
  box-sizing: border-box;
  resize: vertical !important;
  overflow: auto;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form .form-data-item .p-inputtext,
:host ::ng-deep .gc-form-section .sidebar-form .form-data-item .p-inputtextarea {
  width: 100%;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c7c7c7;
  padding: 4px;
}
.assing-agncy .assing-agncy-filed {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    width: 360px;
  }
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  max-width: 300px;
}

::ng-deep .form-list-tooltip {
  max-width: 300px;
  word-break: break-word;
}
::ng-deep .form-list-tooltip hr {
  border-color: rgba(0, 0, 0, 0.1);
  margin: 8px 0;
}

.form-data-icon {
  filter: invert(1);
}

:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown {
  border-radius: 6px;
  border: 1px solid #D1D5DB;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown .p-dropdown-label {
  padding: 12px 16px;
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 16px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .p-autocomplete {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input {
  width: 100%;
  border: none;
  padding: 0;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input:focus {
  box-shadow: none;
}
:host ::ng-deep .assing-agncy-filed .p-autocomplete {
  flex: 1;
}
:host ::ng-deep .p-multiselect {
  border-radius: 6px;
  border: 1px solid #D1D5DB;
  padding: 14px 8px;
  width: 100%;
  background: #fff;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .p-multiselect .p-multiselect-label {
  padding: 0;
  font-size: 16px;
  color: #6b7280;
}
:host ::ng-deep .p-multiselect .p-multiselect-trigger {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
}
:host ::ng-deep .p-multiselect-panel {
  border-radius: 6px;
  margin-top: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
:host ::ng-deep .p-multiselect-panel .p-multiselect-items {
  padding: 8px;
}

.text-center {
  text-align: center;
}

.p-multiselect-wrapper {
  position: relative;
}

.loading-icon {
  color: lightgray;
  position: absolute;
  right: 3rem;
  top: 35%;
  transform: translateY(-50%);
}

:host ::ng-deep .pi-spin {
  animation: fa-spin 0.5s infinite linear !important;
}

:host ::ng-deep .pi-trash {
  margin-left: 10px !important;
}

:host ::ng-deep .p-button-danger:enabled:focus,
:host ::ng-deep .p-button-danger:enabled:active {
  background: #d32f2f;
  outline: none;
  box-shadow: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
